










































import HangupIcon from '@/components/icons/HangupIcon.vue';
import { Component } from 'vue-property-decorator';
import * as vtsx from 'vue-tsx-support';

interface PropTypes {
  onClose: () => void;
  onCall: () => void;
  onDestroy: () => void;
}

enum stepEnum {
  CONNECTING,
  CONNECTED
}

@Component({
  components: { HangupIcon },
  filters: {
    formatTime (distance: number) {
      const minute = 60;
      const hour = minute * 60;
      const day = hour * 24;
      const hours = Math.floor((distance % day) / hour);
      const mins = Math.floor((distance % hour) / minute);
      const secs = Math.floor(distance % minute);
      const paddingDigit = (val: number) => val > 9 ? val : `0${val}`;
      return `${paddingDigit(hours)}:${paddingDigit(mins)}:${paddingDigit(secs)}`;
    },
  },
})
export default class Voice extends vtsx.Component<PropTypes> {
  time = 0;
  stepEnum = stepEnum;
  currentStep = stepEnum['CONNECTING']
  timerId = 0;

  mounted () {
    document.title = 'Voice Call';
    this.$emit('call', this);
  }
  beforeDestroy () {
    clearTimeout(this.timerId);
    this.$emit('destroy');
  }
  handleConnected () {
    this.currentStep = stepEnum['CONNECTED'];
    this.timerId = window.setInterval(() => {
      this.time += 1;
    }, 1000);
  }
  handleHangUp () {
    this.$emit('close');
  }
}
